import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import TierBadge from '@wix/da-ds/pkg/Badges/TierBadge';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import SubscribersOnlyOwnersTooltip from './SubscribersOnlyOwnersTooltip';
import SubscribersOnlyTooltip from './SubscribersOnlyTooltip';
import s from './SubscribersOnly.scss';
var SubscribersOnly = function (_a) {
    var deviation = _a.deviation, className = _a.className, textClassName = _a.textClassName;
    var t = useTranslation().t;
    var _b = useSubscriptionTier(deviation), tier = _b.tier, isOwner = _b.isOwner;
    if (!tier || !tier.author) {
        return null;
    }
    var Tooltip = isOwner
        ? SubscribersOnlyOwnersTooltip
        : SubscribersOnlyTooltip;
    return (React.createElement("div", { className: classnames(s['root'], className) },
        React.createElement(Tooltip, { deviation: deviation, linkClassName: s['subs-link'] },
            React.createElement("div", { className: s['contents'] },
                React.createElement(TierBadge, { size: 40 }),
                React.createElement("span", { className: classnames(s['text'], textClassName) }, t('deviation.tier.subscribersOnly'))))));
};
SubscribersOnly.displayName = 'SubscribersOnly';
export default SubscribersOnly;
//# sourceMappingURL=SubscribersOnly.js.map